import types from '@/vuex/ui/mutations-types.js'

const mutations = {
  [types.SHOW_GLOBAL_LOADING]: (state, payload) => {
    state.globalLoadingMessageArray.unshift(payload.globalLoadingTitle)
    state.globalLoading = true
  },
  [types.HIDE_GLOBAL_LOADING]: (state, payload) => {
    let achou = false
    if (payload && payload.globalLoadingTitle) {
      for (let i = 0; i < state.globalLoadingMessageArray.length; i++) {
        if (state.globalLoadingMessageArray[i] === payload.globalLoadingTitle) {
          state.globalLoadingMessageArray.splice(i, 1)
          achou = true
          break
        }
      }
    }
    // Se não tiver payload ou a mensagem estiver errada, tira uma mensagem
    // qualquer para o loading não ficar rodando infinitamente
    if (achou === false) {
      state.globalLoadingMessageArray.pop()
    }
    if (state.globalLoadingMessageArray.length === 0) {
      state.globalLoading = false
    }
  },
  [types.SET_SNACKBAR]: (state, payload) => {
    state.snackbarType = payload.snackbarType
    state.snackbarText = payload.snackbarText
  },
  [types.SHOW_SNACKBAR]: (state, payload) => {
    state.snackbar = false
    setTimeout(() => {
      state.snackbarType = payload.snackbarType
      state.snackbarText = payload.snackbarText
      state.snackbar = true
    }, 250)
  },
  [types.HIDE_SNACKBAR]: (state) => {
    state.snackbar = false
  },
  [types.SHOW_CONFIRMATION_DIALOG]: (state, payload) => {
    state.confirmationDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?'
    state.confirmationDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.'
    state.confirmationDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não'
    state.confirmationDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim'
    state.confirmationDialogConfig.confirmacaoCallback = payload.confirmacaoCallback
    state.confirmationDialog = true
  },
  [types.HIDE_CONFIRMATION_DIALOG]: (state) => {
    state.confirmationDialog = false
  },
  [types.SHOW_CONFIRMAR_DIALOG]: (state, payload) => {
    state.confirmarDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?'
    state.confirmarDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.'
    state.confirmarDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não'
    state.confirmarDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim'
    state.confirmarDialog = true
  },
  [types.HIDE_CONFIRMAR_DIALOG]: (state) => {
    state.confirmarDialog = false
  },
  [types.SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE]: (state, payload) => {
    state.confirmarDialogPromiseResolve = payload.resolve
  },
  [types.SET_CONFIRMAR_DIALOG_PROMISE_REJECT]: (state, payload) => {
    state.confirmarDialogPromiseReject = payload.reject
  },
  [types.SET_INFORMACAO]: (state, payload) => {
    state.informacao = payload.informacao
  }
}

export default mutations
